import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    FaTimesCircle,
    FaExclamationTriangle,
    FaHome,
    FaPhoneAlt,
    FaRedoAlt,
    FaArrowLeft
} from "react-icons/fa";

export default function BookingFailure() {
    const location = useLocation();
    const navigate = useNavigate();

    /* ===============================
       GET QUERY PARAMS (IMPORTANT)
    =============================== */
    const queryParams = new URLSearchParams(location.search);

    const txnid = queryParams.get("txnid");
    const message =
        queryParams.get("message") || "Payment could not be processed.";
    const reason =
        queryParams.get("reason") ||
        "Bank server timeout, network issue, or insufficient funds.";

    const failureData = {
        transactionId: txnid || "Not Available",
        message,
        reason
    };

    return (
        <div className="d-flex flex-column min-vh-100 bg-light font-sans overflow-hidden">

            {/* HERO SECTION */}
            <div
                className="text-white pt-4 pb-5 position-relative z-index-1"
                style={{
                    background: "linear-gradient(135deg, #dc3545, #ef4444)",
                    minHeight: "280px",
                    borderBottomLeftRadius: "32px",
                    borderBottomRightRadius: "32px"
                }}
            >
                <div className="px-3 mb-2">
                    <div
                        onClick={() => navigate("/dashboard")}
                        className="bg-white bg-opacity-25 rounded-circle p-2 d-inline-flex cursor-pointer btn-native-press"
                    >
                        <FaArrowLeft size={18} />
                    </div>
                </div>

                <div className="container text-center pt-1">
                    <div className="animation-shake d-inline-block bg-white bg-opacity-25 rounded-circle p-3 mb-3">
                        <FaTimesCircle size={50} className="text-white bg-danger rounded-circle" style={{ padding: "2px" }} />
                    </div>
                    <h4 className="fw-bold m-0 tracking-tight">
                        Booking Failed
                    </h4>
                    <p className="opacity-75 small mt-1 fw-medium px-4">
                        Something went wrong while processing your payment.
                    </p>
                </div>
            </div>

            {/* MAIN CARD */}
            <div
                className="container px-3 flex-grow-1 d-flex flex-column"
                style={{
                    marginTop: "-80px",
                    maxWidth: "600px",
                    zIndex: 10
                }}
            >
                <div className="card border-0 shadow-lg rounded-4 overflow-hidden mb-4 animate-slide-up bg-white">
                    <div className="card-body p-4 text-center">
                        <h6 className="fw-bold text-danger mb-2">
                            Transaction Failed
                        </h6>

                        <p className="text-muted small mb-4">
                            {failureData.message}
                        </p>

                        <div className="bg-light p-3 rounded-4 border text-start mb-3">
                            <div className="d-flex align-items-start gap-3">
                                <FaExclamationTriangle
                                    className="text-warning mt-1 flex-shrink-0"
                                    size={16}
                                />
                                <div>
                                    <small className="text-muted fw-bold d-block mb-1" style={{ fontSize: "0.65rem" }}>
                                        POSSIBLE REASON
                                    </small>
                                    <span className="fw-bold text-dark small d-block">
                                        {failureData.reason}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded-3 border">
                            <span className="text-muted small fw-bold">
                                Transaction ID
                            </span>
                            <span className="text-dark fw-bold font-monospace small">
                                {failureData.transactionId}
                            </span>
                        </div>
                    </div>

                    <div className="bg-danger bg-opacity-10 p-3 border-top border-danger border-opacity-25 text-center">
                        <small className="text-dark fw-medium">
                            If money was deducted, it will be refunded within{" "}
                            <strong>5–7 business days</strong>.
                        </small>
                    </div>
                </div>

                {/* ACTIONS */}
                <div className="mt-auto pb-4">
                    <button
                        onClick={() => navigate("/retry-payment?txnid=" + txnid)}
                        className="btn text-white fw-bold py-3 rounded-pill shadow-sm d-flex align-items-center justify-content-center gap-2 w-100 mb-3"
                        style={{
                            background:
                                "linear-gradient(135deg, #dc3545, #ef4444)"
                        }}
                    >
                        <FaRedoAlt size={16} /> Retry Payment
                    </button>

                    <button
                        onClick={() => navigate("/dashboard")}
                        className="btn bg-white text-dark border fw-bold py-3 rounded-pill shadow-sm d-flex align-items-center justify-content-center gap-2 w-100 mb-4"
                    >
                        <FaHome /> Go to Home
                    </button>

                    <div className="text-center">
                        <small className="text-muted fw-medium">
                            Need urgent help?
                        </small>
                        <br />
                        <a
                            href="tel:+919876543210"
                            className="fw-bold text-primary text-decoration-none mt-1 d-inline-block p-2"
                        >
                            <FaPhoneAlt className="me-2 small" /> Contact Support
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}